import * as Yup from 'yup';
import { EmailValidationRegex } from '../constants';

export const PasswordInputValidation = Yup.string()
  .max(256, 'Password must be less than 256 characters')
  .min(8, 'Password must be at least 8 characters')
  .trim('Password cannot have leading or trailing spaces')
  .matches(/[a-z]/, 'Password must have at least one lowercase char')
  .matches(/[A-Z]/, 'Password must have at least one uppercase char')
  .matches(/[0-9]+/, 'Password must have at least one number')
  .required('Password is required');

export const isValidEmail = (email: string) => EmailValidationRegex.test(email);
